import chroma from "chroma-js";
export const alpha = (color, opacity) => {
    return chroma(color).alpha(opacity).hex();
};
//# sourceMappingURL=colors.js.map